const symbols = {
  'ZAR': 'R',
  'USD': '$',
  'GBP': '£',
  'THB': '฿',
  'EUR': '€',
  'NAM $': 'N$',
  'NAM$': 'N$',
  'NAM': 'N$',
  'NAD': 'N$',
  'AOA': 'Kz',
  'HRK': 'kn',
};

module.exports = function currencySymbol(code) {
  if (!code) return '';

  return symbols[code] || code;
};
